<div class="back"></div>
<div class="div-center">
  <div class="row items-center">
    <div class="col col-sm-4 col-md-4">
      <div class="row">
        <div class="col">
          <img src="/images/cone.png">
        </div>
      </div>
    </div>
    <div class="col-sm-8 col-md-8">
      <div class="row">
        <div class="col">
          <h1> <span class="text-danger"><strong>{{'EXPRESSOES.EITA' | transloco }}</strong></span> <strong>{{
              'LOGIN.FALHOU' | transloco }}</strong></h1>
        </div>
      </div>
      <div class="row">
        <div class="col">

          <p class="lead">
            {{'LOGIN.TENTE_NOVAMENTE' | transloco}}
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <dx-button class="aias-button-principal" [text]="'LOGIN.FACA_LOGIN' | transloco"
            [routerLink]="['/login']"></dx-button>
        </div>
      </div>
    </div>